import { render, staticRenderFns } from "./EditDriedAbaloneCookingSheet.vue?vue&type=template&id=3bccbc8c&"
import script from "./EditDriedAbaloneCookingSheet.vue?vue&type=script&lang=js&"
export * from "./EditDriedAbaloneCookingSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditDriedAbaloneCookingSheet.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
